'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _Overlay = require('./Overlay');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Close = require('./Close');

var _Close2 = _interopRequireDefault(_Close);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _offscreenCss = require('./utils/offscreenCss');

var _offscreenCss2 = _interopRequireDefault(_offscreenCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var majorScale = _theme2.default.majorScale,
    minorScale = _theme2.default.minorScale,
    borderRadius = _theme2.default.borderRadius,
    colors = _theme2.default.colors,
    rawColors = _theme2.default.rawColors,
    textStyles = _theme2.default.textStyles;


var overlayStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

var mainCss = (0, _glamor.css)({
  position: 'relative',
  maxWidth: majorScale(72),
  border: '1px solid ' + colors.borderColor,
  borderRadius: borderRadius[1],
  background: colors.white,
  animationDuration: _theme2.default.animationDuration.fast,
  animationTimingFunction: _theme2.default.animationEasing.standard,
  animationFillMode: 'forwards'
});

var titleCss = (0, _glamor.css)(_extends({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: majorScale(2) + ' ' + majorScale(3),
  borderBottom: '1px solid ' + colors.borderColor
}, textStyles.display3));

var buttonCss = (0, _glamor.css)({
  padding: majorScale(1),
  marginRight: '-' + majorScale(1),
  background: 'none',
  cursor: 'pointer',
  color: rawColors.grey300,
  lineHeight: 0,
  ':hover, :focus': {
    outline: 'none',
    color: rawColors.grey400
  }
});

var openAnimation = _glamor.css.keyframes('openAnimation', {
  from: {
    transform: 'scale(0.8)',
    opacity: 0
  },
  to: {
    transform: 'scale(1)',
    opacity: 1
  }
});

var closeAnimation = _glamor.css.keyframes('closeAnimation', {
  from: {
    transform: 'scale(1)',
    opacity: 1
  },
  to: {
    transform: 'scale(0.8)',
    opacity: 0
  }
});

var parseProps = function parseProps(_ref) {
  var className = _ref.className,
      children = _ref.children,
      title = _ref.title,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'title', 'isOpen', 'onClose']);

  return props;
};

var Dialog = function (_Component) {
  _inherits(Dialog, _Component);

  function Dialog(props) {
    _classCallCheck(this, Dialog);

    var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this));

    _this.state = {
      isMounted: props.isOpen,
      isClosing: false
    };

    _this.handleFadeEnd = _this.handleFadeEnd.bind(_this);
    return _this;
  }

  _createClass(Dialog, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.isOpen && nextProps.isOpen) {
        this.setState({ isMounted: true, isClosing: false });
      }

      if (this.props.isOpen && !nextProps.isOpen) {
        this.setState({ isMounted: true, isClosing: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          onClose = _props.onClose,
          children = _props.children;
      var _state = this.state,
          isMounted = _state.isMounted,
          isClosing = _state.isClosing;


      if (!isMounted) return null;

      var style = {
        animationName: '' + (isClosing ? closeAnimation : openAnimation)
      };

      return _react2.default.createElement(
        _Overlay2.default,
        _extends({
          onClick: onClose,
          fadeOut: isClosing,
          onFadeEnd: this.handleFadeEnd
        }, overlayStyles),
        _react2.default.createElement(
          _Box2.default,
          _extends({}, parseProps(this.props), {
            is: 'section',
            className: '' + mainCss,
            style: style,
            role: 'dialog',
            'aria-label': title
          }),
          _react2.default.createElement(
            _Box2.default,
            { is: 'h2', className: '' + titleCss },
            title,
            onClose && _react2.default.createElement(
              _Box2.default,
              { is: 'button', className: '' + buttonCss, onClick: onClose },
              _react2.default.createElement(
                'div',
                { className: '' + _offscreenCss2.default },
                'Close'
              ),
              _react2.default.createElement(_Close2.default, { width: minorScale(3), height: minorScale(3) })
            )
          ),
          _react2.default.createElement(
            _Box2.default,
            { padding: majorScale(3) },
            children
          )
        )
      );
    }
  }, {
    key: 'handleFadeEnd',
    value: function handleFadeEnd() {
      if (!this.state.isClosing) return;
      this.setState({ isMounted: false, isClosing: false });
    }
  }]);

  return Dialog;
}(_react.Component);

Dialog.propTypes = _extends({}, _Box2.default.propTypes, {
  title: _propTypes2.default.node.isRequired,
  isOpen: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.node.isRequired,
  onClose: _propTypes2.default.func
});

Dialog.defaultProps = {
  isOpen: false
};

Dialog.displayName = 'Dialog';

exports.default = Dialog;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Dialog.js
// module id = 1122
// module chunks = 0